const AUTH_TOKEN_KEY = "auth_token";

/**
 * Get the current session/auth token
 * @returns {string|null} The auth token or null if not found
 */
export const getSessionId = () => localStorage.getItem(AUTH_TOKEN_KEY);

/**
 * Set the auth token
 * @param {string} token - The auth token to store
 */
export const setSessionId = (token) => localStorage.setItem(AUTH_TOKEN_KEY, token);

/**
 * Remove the auth token
 */
export const clearSession = () => localStorage.removeItem(AUTH_TOKEN_KEY);

/**
 * Check if user is authenticated
 * @returns {boolean} Whether user has a valid token
 */
export const isAuthenticated = () => !!getSessionId();
